
import config from '../../config';

function HttpsRedirect(props) {
  const FORCE_HTTPS = config.get('FORCE_HTTPS');
  if (window.location.protocol !== 'https:' && FORCE_HTTPS === 'true') {
    window.location.protocol = "https:";
    return null;
  }
  return props.children;
}

export default HttpsRedirect;
